module.exports = __webpack_public_path__ + "static/media/9.c8a25ae9.jpg";